// API helpers for academy_notifications (notifications CRUD)
import supabase from "../../../../supabaseClient";

// Fetch notifications for a user (optionally filter unread)
export const fetchNotifications = async (recipient_id, { unreadOnly = false } = {}) => {
  let query = supabase
    .from('academy_notifications')
    .select('*')
    .eq('recipient_id', recipient_id)
    .order('created_at', { ascending: false });
  if (unreadOnly) query = query.eq('read', false);
  return await query;
};

// Mark a notification as read
export const markNotificationRead = async (id) => {
  return await supabase
    .from('academy_notifications')
    .update({ read: true })
    .eq('id', id);
};

// Mark all notifications as read for a user
export const markAllNotificationsRead = async (recipient_id) => {
  return await supabase
    .from('academy_notifications')
    .update({ read: true })
    .eq('recipient_id', recipient_id)
    .eq('read', false);
};

// Create a notification
export const createNotification = async (notification) => {
  return await supabase
    .from('academy_notifications')
    .insert([notification]);
};

// Delete a notification
export const deleteNotification = async (id) => {
  return await supabase
    .from('academy_notifications')
    .delete()
    .eq('id', id);
};

// Delete all notifications for a user
export const deleteAllNotifications = async (recipient_id) => {
  return await supabase
    .from('academy_notifications')
    .delete()
    .eq('recipient_id', recipient_id);
};
